import { MinusIcon } from '@heroicons/react/20/solid';
import { twMerge } from 'tailwind-merge';

type Props<T> = {
  value: T | null | undefined;
  className?: string;
  suffix?: string;
  prefix?: string;
  renderValue?: (value: T) => React.ReactNode;
};

export function ValueOrDash<T>({
  value,
  className,
  suffix = '',
  prefix = '',
  renderValue,
}: Props<T>): React.ReactNode {
  if (!value) {
    return (
      <MinusIcon
        className={twMerge('text-zinc-800/30 size-4 dark:text-zinc-500 inline-block', className)}
      />
    );
  }

  if (renderValue) {
    return (
      <div className="inline-block">
        {prefix}
        {renderValue(value)}
        {suffix}
      </div>
    );
  }

  return (
    <div className="inline-block">
      {prefix}
      <span>{value as React.ReactNode}</span>
      {suffix}
    </div>
  );
}
